if ($('#app-form-national-airing-views-edit').length) {

    //$('#form_fields').multiSelect(searchableMultiSelectDef);

    $("#allyear").on('click', function(){
        $("#quarterdiv").hide();
        $("#monthdiv").hide();
    });

    $("#allquarter").on('click', function(){
        $("#quarterdiv").show();
        $("#monthdiv").hide();
    });

    $("#allmonth").on('click', function(){
        $("#quarterdiv").hide();
        $("#monthdiv").show();
    });

    $("#primary_demo_type_p").on('click', function(){
        resetDemo("A");
    });

    $("#primary_demo_type_m").on('click', function(){
        resetDemo("M");
    });

    $("#primary_demo_type_f").on('click', function(){
        resetDemo("W");
    });

    $("#primary_demo_type_hh").on('click', function(){
        resetDemo("HH");
    });

    $(document).ready(function(){
        show_loader();
        if(report['demo_type']== 'p')
            resetDemo("A");
        else  if(report['demo_type']== 'm')
            resetDemo("M");
        else  if(report['demo_type']== 'f')
            resetDemo("W");
        else
            resetDemo("HH");
        // resetStations();

        $('#interval_calendar input').each(function () {
            if (this.checked)
                $(this).prop('checked', false);

            if(report.quarters !== '' && report.quarters !== null){
                if($(this).val() === 'allquarter')
                    $(this).prop('checked', true);
                $('#quarterdiv').css('display', 'block');
                $('#monthdiv').css('display', 'none');
            }
            if(report.months !== '' && report.months !== null){
                if($(this).val() === 'allmonth')
                    $(this).prop('checked', true);
                $('#quarterdiv').css('display', 'none');
                $('#monthdiv').css('display', 'block');
            }
            if((report.months === '' || report.months === null) && (report.quarters === '' || report.quarters === null)) {
                if ($(this).val() === 'year')
                    $(this).prop('checked', true);
                $('#quarterdiv').css('display', 'none');
                $('#monthdiv').css('display', 'none');
            }
        });


        $.ajax({
            type: "GET",
            url: '/ratings/comscore/metadata/markets',
            dataType: 'json',
            success: function (data) {
                console.log(data);
                var html = '';

                $.each(data['result_rows'], function (index, value) {
                    if(report.market === value[0])
                        html += '<option value="'+ value[0] +'" selected >'+ value[1] +'</option>';
                    else
                        html += '<option value="'+ value[0] +'" >'+ value[1] +'</option>';
                });
                $("#form_market").append(html);

                var market= $("#form_market option:selected").val();
                $("#selmarket").val($("#form_market option:selected").text());
                resetStations(market, 1);

                $("#form_market").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                }).on('select2:select', function (evt) {
                    resetStations($(this).val(), 0);
                    $("#selmarket").val($("#form_market option:selected").text());
                });
                $("#stream").select2()
               /* if(report['demo_type']== 'p')
                    resetDemo("A");
                else  if(report['demo_type']== 'm')
                    resetDemo("M");
                else  if(report['demo_type']== 'f')
                    resetDemo("W");
                else
                    resetDemo("HH");*/
               // resetDemo(report['demo_type']);

                $('#form_series').multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                });
                resetStations();

                $("#rpt_sort_by").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                }).on('select2:select', function (evt) {
                    //tvRankerOnMarketChange();
                    //tvRankerFormReset(1);
                });

                $("#rpt_avg_by").select2({
                    minimumResultsForSearch: 10,
                }).on('select2:select', function (evt) {

                });

                $("#form_quarter").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                }).on('select2:select', function (evt) {
                    //tvRankerOnMarketChange();
                    //tvRankerFormReset(1);
                });

                $("#form_year").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                }).on('select2:select', function (evt) {
                    //tvRankerOnMarketChange();
                    //tvRankerFormReset(1);
                });

                $("#form_month").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                }).on('select2:select', function (evt) {
                    //tvRankerOnMarketChange();
                    //tvRankerFormReset(1);
                });

                $("#form_dayparts").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                }).on('select2:select', function (evt) {
                    //tvRankerOnMarketChange();
                    //tvRankerFormReset(1);
                });

                hide_loader();
            },
            error: function (err) {
                console.log(err);
                hide_loader();
            }
        });

    });

    var resetDemo = function(type){
        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/comscore/demos',
            dataType: 'json',
            success: function (data) {
                console.log(data);
                var html = '';
                data['result_rows'].sort(function(a,b){
                    var au = a[2];
                    var bu = b[2];
                    return au.toString().localeCompare(bu);
                });
                $("#seldemo").val("") ;
                $.each(data['result_rows'], function (index, value) {
                    if(value[1] !== null && value[10] !== null &&  value[1].indexOf(type) !== -1 && (value[10].indexOf('Age Range') !== -1 || (type === "HH" && value[10].indexOf('Household Composition') !== -1))) {
                        var ddemo = value[1].replace("A1", "1").replace("A2", "2").replace("A3", "3").replace("A4", "4").replace("A5", "5").replace("A6", "6").replace("M1", "1").replace("M2", "2").replace("M3", "3").replace("M4", "4").replace("M5", "5").replace("M6", "6").replace("W1", "1").replace("W2", "2").replace("W3", "3").replace("W4", "4").replace("W5", "5").replace("W6", "6");
                        var sel='';
                        console.log(value[0]);
                        if(report.demo == value[0] )
                         sel = 'selected';
                        if(value[10].indexOf('Household Composition') !== -1 && html == "") {
                            var selected = (report.demo == 0) ? 'selected' : "";
                            html += '<option value="0" ' + selected + '>---</option>';
                        }
                        html += '<option value="' + value[0] + '" '+sel+'>' + ddemo + '</option>';
                        $("#seldemo").val(ddemo);
                    }
                });
                $("#demo_ids").html(html);
                $('#demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    $("#seldemo").val($("#demo_ids option:selected").text());
                });
                $("#seldemo").val($("#demo_ids option:selected").text());
                hide_loader();
            },
            error: function (err) {
                hide_loader();
            }
        });
    };
    $('#demo_ids').on('change', function(){
        var x=  $("#demo_ids option:selected");
        $("#seldemo").val($(x).text());

    });
    var resetStations = function(){
        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/comscore/networks',
            dataType: 'json',
            success: function (data) {
                $("#form_series").html(data);
                $('#form_series').multiSelect('refresh');
                $('#form_series option').each(function () {
                   if(report['networks'].indexOf($(this).val()) !== -1){
                       $(this).attr('selected', true);
                       $(this).prop('selected', true);
                   }
                });

                $('#form_series').multiSelect('refresh');


                hide_loader();
            },
            error: function (err) {
                hide_loader();
            }
        });
    };

    $('#form_submit_edit').on('click', function (e) {
        var stations= $('#form_series');
        var years= $('#form_year');
        var daypart= $('#form_dayparts');
        var p=false;
        var pp= false;

            if( $(stations).val().length !== 0 ) {
                p = true;
                pp= true;
            }
            else
                global_notification('warning','Please select at least one Network');

            if(p === true && pp === true && $(years).val().length === 0){
                p = false;
                pp = false;
                global_notification('warning','Please select at least one calendar year.');
            }


        if($(daypart).val().length === 0 && p === true)
        {
            pp = false;
            global_notification('warning','Please select at least one Daypart');
        }
        if(pp === true) {
            if(( $("input:radio[name=calendar_opt]:checked").attr('value')==='allquarter' && $('#form_quarter').val().length > 0) || ($("input:radio[name=calendar_opt]:checked").attr('value')==='allmonth' && $('#form_month').val().length > 0)
                || $("input:radio[name=calendar_opt]:checked").attr('value')==='year') {
                $("#seldemo").val($("#demo_ids option:selected").text());
                show_loader();
                $('#app-form-national-airing-views-edit').submit();
            }
            else {
                if( $("input:radio[name=calendar_opt]:checked").attr('value')==='allquarter')
                    global_notification('warning','Please select at least one Quarter');
                if( $("input:radio[name=calendar_opt]:checked").attr('value')==='allmonth')
                    global_notification('warning','Please select at least one Month');
            }

        }
    });


}